export default {
    site: {
        common: {
            hello: "Γειά",
            thankYou: "Ευχαριστώ",
            forMoreInfo: "για περισσότερες πληροφορίες",
            hoverOverColumnHeaders: "Σύρετε το ποντικί σας πάνω από τις κεφαλίδες στηλών για περισσότερες πληροφορίες",
            username: "όνομα χαρακτήρα",
            score: "Βαθμολογία",
            points: "Πόντοι",
            pointsAbbreviation: "πόντοι",
            chapter: "Κεφάλαιο",
            tier: "Βαθμίδα",
            t1: "T1",
            t2: "T2",
            t3: "T3",
            collectionsPerDay: "Συλλογές ανά ημέρα",
            relicBoostPercent: "Ενίσχυση Τεχνουργημάτων %",
            mountainHallPercentShort: "Αίθουσες του βουνού %", // used in table heading keep it short.
            updated: "ανανεώθηκε",
            lastUpdated: "Τελευταία ανανέωση",
            created: "δημιουργήθηκε",
            role: "Τίτλος",
            Fellow: 'Μέλος',
            Ambassador: 'Πρέσβης',
            Mage: 'Μάγος',
            Archmage: 'Αρχιμάγος',
            saveChanges: "Αποθήκευση αλλαγών",
            copy: "Αντιγραφή",
            close: "Κλείσιμο",
            cancel: "Ακύρωση",
            action: "Action",
            date: "Ημερομηνία",
            Left: "Αποχώρηση",
            Joined: "Ένταξη",
            human: "Άνθρωπος",
            elf: "Ξωτικό",
            search: "Αναζήτηση",
            enter: "Εισαγωγή",
            yes: "Ναι",
            no: "Όχι",
            tournament: "Τουρνουά",
            tournaments: "Τουρνουά",
            fellowship: "Συντροφιά",
            player: "Παίκτης",
            member: "Μέλος",
            history: "Ιστορικό",
            tournamentHistory:  "Ιστορικό τουρνουά",
            scoreHistory: "Ιστορικό βαθμολογίας",
            server: "Σέρβερ",
            lastWeekGain: "Κέρδη Εβδομάδας",
            comingSoon: "Έρχεται σύντομα",
            chest: "θησαυρός",
            yourServer: "Ο Σέρβερ σας",
            allServers: "Όλοι οι Σέρβερ",
            boosts: "Ενισχύσεις",
            marble: "μάρμαρο",
            steel: "ατσάλι",
            planks: "ξυλεία",
            crystal: "κρύσταλλο",
            scrolls: "πάπυροι",
            silk: "μετάξι",
            elixir: "ελιξίριο",
            magic_dust: "μαγική σκόνη",
            gems: "πολύτιμοι λίθοι",
            sentient: "έμψυχα",
            goods: "αγαθά",
            average: "μέσος όρος",
            expansions: 'Επεκτάσεις', // 5x5 grids
            cultureBoostMinimum: 'Ενίσχυση Πολιτισμού Ελάχιστο',
            cultureBoostCalculated: 'Ενίσχυση Πολιτισμού Υπολογίστηκε',
            neighborlyHelp: 'Βοήθεια γειτόνων',
            neighborlyHelpAbbreviation: 'ΒΓ'
        },
        // HIGH PRIORITY
        nav: {
            home: "Αρχική",
            players: "Παίκτες",
            fellowships: "Συντροφιές",
            tournaments: "Τουρνουά",
            contact: "Επικοινωνία",
            donate: "Δωρεά",
            faq: "FAQ",
            news: "Νέα",
            privacyPolicy: "Πολιτική ιδιωτικού απορήτου",
            me: "Εγώ",
            myFellowship: "Η συντροφιά μου",

            // NOTE USED AT THE MOMENT
            globalStats: "Παγκόσμια Στατιστικά",
            articles: "Articles",
            fellowshipAdventure: "Περιπέτειες Συντροφιάς",
            recruit: "Recruit",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Προβολή πόλης στο ElvenArchitect"
            ,obtainingLink: "Απόκτηση Link"
            ,successMessage: "Επιτυχία! Κάντε κλικ στο λινκ για μεταφορά στο Elven Architect"
            ,ageOfLink: "Το παραπάνω λινκ θα εμφανίσει την πόλη όπως ήταν: "
            ,clickToGetCurrentCity: "<-- Κάντε κλικ για τρέχον πόλη",
        },
        // High Priority
        playerSelection: {
            headline: "Προβολή σελίδας ως",
            description: "Αυτό θα ενημερώσει διάφορα σημεία του ιστοτόπου τα οποία είναι προσαρμοσμένα για τον χρήστη. Παραδείγματα περιλαμβάνουν: την συντροφιά μου, τον χαρακτήρα μου, τουρνουά και την σελίδα κατάταξης.",
            youAreViewing: `Τώρα βλέπετε την σελίδα ως {username} στον {serverName}.`,
            changeUser: "Αλλαγή Παίκτη",
            enterYourUsernameToGetStarted: "Εισάγετε το όνομα χαρακτήρα σας στο Elvenar για να ξεκινήσετε",
            thisIsNotASignup:"Δεν πρόκειται για διαδικασία εγγραφής. Καταχωρώντας το όνομα χρήστη σας, απλά προσαρμόζουμε κατάλληλα τον ιστότοπο. Υπάρχουν πολλοί σέρβερ στο Elvenar και θα εμφανίσουμε τα αποτελέσματα κατάταξης για τον δικό σας. "
        },
        searchBoxes: {
            enterFellowshipName: 'Εισάγετε το όνομα της Συντροφιάς σας.',
            instructions: "Πληκτρολογήστε το όνομα και επιλέξτε μία.",
            noFellowship: "Καμία Συντροφιά",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "ημέρες πριν",
            minsAgo: "λεπτά πριν",
            hoursAgo: "ώρες πριν",
            justNow: "μόλις τώρα",
            never: "Ποτέ",
        },
        home: {
            welcome: "Καλωσήρθατε στο Elven Stats!",
            youAreViewing: "Τώρα βλέπετε την σελίδα ως {username} στον {serverName}.",
            youCanChange: "Μπορείτε να αλλάξετε τον χρήστη κάνοντας κλικ στο άβαταρ πάνω δεξιά -ή- <router-link to='/contact'>κάνοντας κλικ στην σελίδα</router-link>",
            features: {
                headline: "Χαρακτηριστικά",
                fellowshipAdministration: {
                    headline: "<strong>Ευκολότερη</strong> Διαχείρηση Συντροφιάς",
                    bullet1: "Αυτόματη παρακολούθηση των ενισχυμένων αγαθών για να σας βοηθήσει να ισορροπήσετε την συντροφιά σας",
                    bullet2: "Αυτόματη παρακολούθηση/δημιουργία εβδομαδιαίων μυνημάτων αναφορών συμπεριλαμβανομένων των πόντων, συμμετοχή στο τουρνουά, μηνιαία ανάπτυξη και προσωπικά ρεκόρ",
                    bullet3: "Βοήθεια στον προσδιορισμό ασταθιών στις παραγωγές των συντρόφων σας όπως προμήθειες ή λανθασμένες αναλογίες βαθμίδων",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Ενσωμάτωση</strong> στο ElvenArchitect ",
                    description: "Φορτώστε μέσα σε δευτερόλεπτα την πόλη σας ακριβώς όπως είναι στο ElvenArchitect! Χρησιμοποιήστε αυτό για να σχεδιάσετε καλύτερα την επόμενη μεγάλη αναδιοργάνωση της πόλης σας ή για να βρείτε χώρο που δεν ξέρατε οτι είχατε! Αναζητήστε το λογότυπο του ElvenArchitect στις σελίδες του παίκτη."
                },
                advancedRankingLists: {
                    headline: "Προχωρημένες <strong>Λίστες Κατάταξης</strong>",
                    bullet1: "Λίστα Κατάταξης ανά Επεκτάσεις (για σύγκριση με άλλους παίκτες στο ίδιο στάδιο)",
                    bullet2: "Προβολή ενισχυμένων αγαθών, αριθμό κεφαλαίου και άλλα στις λίστες παικτών",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Παρακολούθηση</strong> Τουρνουά Συντροφιάς",
                    description: "Συγκρίνετε την απόδοση της συντροφιάς σας με άλλες. Προκαλέστε άλλες συντροφιές σε μια φιλική αναμέτρηση!",
                },
                matchMaking: {
                    headline: "<strong>Βρείτε</strong> νέα μέλη",
                    description: "Το ElvenStats παρακολουθεί τα ενισχυμένα αγαθά των παικτών και τις αναλογίες παραγωγής αγαθών των συντροφιών. Με αυτές τις πληροφορίες, οι συντροφιές μπορούν να προσκαλέσουν τους κατάλληλους υποψήφιους για να εξισορροπήσουν τα αγαθά τους. Οι χρήστες που αναζητούν συντροφιά μπορούν να βρούν συντροφιές οι οποίες χρειάζονται τα ενισχυμένα αγαθά τους. Γλιτώστε χρόνο και απορρίψεις!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Κατάταξη",
                points: "Πόντοι",
                medianUserScore: "Μέσο <strong>Σκορ Χρήστη</strong>",
                memberCount: "<strong>Μέλη</strong>",
            },
            barCharts: {
                clickSlice: "Κάντε κλικ σε μια μπαρα για λεπτομέρειες (ανα μέλος)",
                tier1: "Βαθμίδα 1",
                tier2: "Βαθμίδα 2",
                tier3: "Βαθμίδα 3",
                drillDown: "Πίσω {0}"
            },
            idealCandidate: {
                heading: "Το ιδανικό μέλος",
                description: "θα είχε περίπου {medianScore} πόντους κατάταξης και θα είχε ένα ή περισσότερα από τα παρακάτω ενισχυμένα αγαθά: {boosts}",
                note: "Μερικοί συνδυασμοί ενισχυμένων αγαθών δεν είναι δυνατοί. Δείτε {0}"
            },
            memberGoodsTable: {
                heading: "Παραγωγές Αγαθών Μελών",
                description: `Αυτός ο πίνακας υπολογίζει πόσα από το κάθε αγαθό παράγει η συντροφιάς σας. Με βάση μιας υπόθεσης για το ποσοστό ενίσχυσης αγαθών
                των μελών και υποθέτωντας οτι κάθε μέλος συλλέγει παραγωγές 3 φορές την ημέρα (2x9ω and 1x3ω). Για βελτίωση της ακρίβειας, ρωτήστε τα μέλη της συντροφιάς σας για τις πραγματικές τιμές και εισάγετε τις παρακάτω. Μπορείτε να
                αποθηκεύσετε τι εισάγετε ώστε να εμφανιστεί την επόμενη φορά που θα φορτώσετε αυτή την σελίδα. Τα ραβδογράμματα θα ανανεώνονται αυτόματα κάθε φορά που κάνετε μία αλλαγή. Hover over the column
                headers for more information about a particular column.'
                `,
                refreshButtonText: 'Ανανέωση Λίστας Μελών',
                refreshButtonTip: 'Αυτό θα εισάγει τα νέα μέλη, αφαιρέσει τα παλιά, ανανεώσει τους ρόλους και τα τρέχον σκορ.',
                inactiveWarningTip: 'Πιθανόν ανενεργός χρήστης, Ενημερώθηκε τελευταία: {0}',
                collectsPerDayValidation: "Μεταξύ 1-6",
                boostPercentValidation: "Μεταξύ 40 - 700, μην εισάγετε το μπόνους απο τις αίθουσες του βουνού",
                perDayShort: "/ημέρα",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Η κατάταξη των παικτών δεν ανανεώνεται βάση της πραγματικής ώρας. Ανανεώνεται μερικές φορές την εβδομάδα.",
                chapterTip: "Αυτό είναι το κεφάλαιο στο οποίο βρίσκεται ο κάθε παίκτης.  Για παράδειγμα: Τα Στοιχειά = 12, Μικρούληδες = 11, και άλλα.",
                boostTip: "Η ενίσχυση του παίκτη και το ποσό που ΠΑΡΑΓΕΙ κάθε μέρα.",
                collectsPerDayTip: `***EDITABLE*** <br/>Συλλογές ανά ημέρα. Αυτός είναι ο αριθμός των φορών κάθε ημέρα που ο χρήστης συλλέγει τις παραγωγές από τα εργοστάσια. Πρέπει να είναι μια τιμή μεταξύ 1 - 6.  1 = 1x24ω, 2=2x9ω, 3=2x9ω + 1x3ω, 4=1x9ω + 3x3ω, 5=4x3ω + 1x9ω, 6=5x3ω + 1x9ω<BR/>Παρακαλούμε, δείτε τις Συχνές ερωτήσεις "FAQ" για περισσότερα.`,
                relicBoostPercentTip: `***EDITABLE***<br/>Το ποσοστό ενίσχυσης απο τεχνουργήματα είναι μεταξύ 40-700.  Δεν θα πρέπει να περιλαμβάνει το μπόνους απο τις αίθουσες του βουνού.  Αυτό εντοπίζεται αυτόματα και προστίθεται στον αριθμό.`,
                mountainHallPercentTip: "Αυτό είναι το ποσοστό ενίσχυσης που εντοπίσαμε για τον χρήστη από τις Αίθουσες του Βουνού.  Χρησιμοποιείται σε συνδυασμό με το ποσοστό ενίσχυσης %'s για να υπολογίσει το σύνολο της ενίσχησης",
                updatedTip: "Αυτός είναι ο χρονος που αναλύθηκε τελευταία φορά η πόλη του παίκτη.  Η διαδικασία αυτή καθορίζει τις ενισχύσεις, δεδομένα για το elven architect, υπολογίζει παραγωγή από όλα τα εργοστάσια, Αίθουσες των Βουνών %, και άλλα. Τα δεδομένα του χάρτη της πόλης συλλέγονται αυτόματα ανά περιόδους αλλά μπορείτε να ανανεώσετε χειροκίνητα κάνοντας κλικ στο κουμπί ανανέωσης παρακάτω.",

            },
            coinsAndSuppliesTable: {
                heading: "Παραγωγή Νομισμάτων / Προμηθειών",
                description: `Η σημαντική στήλη εδώ είναι οι "Υπολοιπόμενες προμήθειες" καθώς δείχνει αν κάποιο μέλος θα παράγει αρκετές προμήθειες για να κρατήσει τα
                εργοστάσια να παράγουν συνεχόμενα 24/7.  Χρησιμοποιείστε τους διακόποτε παρακάτω για να λάβετε υπόψη το ελάχιστο μπόνους πολιτισμού των παικτών (το οποίο είναι το μπόνους που θα είχατε χωρίς καμία βοήθεια γειτόνων)
                και/ή τον αριθμό των φορών που ο παίκτης συλλέγει κάθε μέρα (όπως ορίζεται στον πίνακα αγαθών ανωτέρω).  Η απενεργοποιηση και των δύο διακόπτων είναι χρήσιμη αν επιθυμείτε να δείτε πόσες από τις προμήθειες αποδίδονται
                σε περισσότερα εργοστάσια ή υψηλότερο μπόνους πολιτισμού. Τέλος, σημειώστε πως έχωντας χαμηλό αρνητικό (~10% του συνολικού) υπολοιπόμενο αριθμό προμηθειών  είναι αρκετά συχνό. Υπάρχουν πολλοί τρόποι με τους οποίους οι παίκτες
                ενισχύουν την απόκτηση προμηθειών όπως η επίσκεψη σε γείτονες, αποστολές, παραγωγή προμηθειών σε πιο συχνά διαστήματα (Ποτά, Απλά εργαλεία, Ψωμί...) ή κάνοντας χρήση της Ισχύς των Προμηθειών (ξόρκι) .
                Σκεφτείτε την αρνητική τιμή σαν το τι θα πρέπει να παράγετε  καθημερινά χρησιμοποιώντας μία από αυτές τις επιλογές.
                ΣΗΜΕΙΩΣΗ: Για την ώρα η παραγωγή μονάδων δεν λαμβάνεται υπόψιν στις προμήθειες που χρησιμοποιήθηκαν (Μόνο αγαθά των τριών βαθμίδων), συνεπώς μπορεί να χρειαστείτε περισσότερες προμήθειες.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Ελάχιστη Ενίσχυση %",
                made: "Παραγωγή",
                used: "Χρήση",
                left: "Υπόλοιπο",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Το μπόνους πολιτισμού.  ΣΗΜΑΝΤΙΚΟ: αυτό υπολογίζεται υποθέτοντας καμία βοήθεια γειτόνων σε πολιτιστικά κτίρια. Στην πραγματικότητα, αυτό μπορεί να είναι υψηλότερο στις πόλεις σας.",
                moneyComputedTip: "Το ποσό των νομισμάτων που παράγεται κάθε μέρα, συμπεριλαμβανομένων των Αρχαίων θαυμάτων που παράγουν νομίσματα",
                moneyUsedComputedTip: "Το ποσό των νομισμάτων που χρειάζεται για την παραγωγή αγαθών of coins.",
                moneyRemainingComputedTip: "Νομίσματα μείον Νομίσματα που δαπανήθηκαν, είναι το πλεόνασμα ή έλλειψη σε νομίσματα που θα έχει ο παίκτης κάθε μέρα",
                suppliesComputedTip: "Ο αριθμός των προμηθειών που θα παράγωνταν αν όλα τα εργαστήρια παρήγαγαν 24x1 (Εργαλειοθήκες) + οποιαδήποτε αρχαία θαύματα (δεν περιλαμβάνει μπόνους απο σετ κτιρίων)",
                suppliesUsedComputedTip: "Ο αριθμός των προμηθειών που καταναλώθηκαν για την παραγωγή αγαθών. Δεν περιλαμβάνει προμήθειες που δαπανήθηκαν στους στρατώτες σας! Δείτε την εξήγηση παραπάνω",
                suppliesRemainingComputedTip: "Προμήθειες μείον Προμήθειες που δαπανήθηκαν, είναι το πλεόνασμα ή έλλειψη σε προμήθειες που θα έχει ο παίκτης κάθε μέρα",
                manaTip: "Το ποσό Mana που παράγεται κάθε 24 ώρες (δεν περιλαμβάνει το Αββαείο των Δράκων)",
            },
            popCultureTable: {
                heading: "Λεπτομέρειες Πλυθησμού / Πολιτισμού",
                description: 'Ο παρακάτω πίνακας δείχνει τον πλυθησμό/πολιτισμό για κάθε μέλος. Hover over the column headers for more information.',

                // Icon Sub-Headings
                minBoostPercent: "Ελάχιστη Ενίσχυση %",
                levels: "Επίπεδα",
                total: "Σύνολο",
                working: "Εργαζόμενος",
                available: "Διαθέσιμος",
                required: "Απαιτούμενος",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Το σύνολο των επιπέδων αρχαίων θαυμάτων του κάθε παίκτη.",
                cultureBoostPercentTip: "Το μπόνους πολιτισμού.  ΣΗΜΑΝΤΙΚΟ: αυτό υπολογίζεται υποθέτοντας καμία βοήθεια γειτόνων σε πολιτιστικά κτίρια. Στην πραγματικότητα, αυτό μπορεί να είναι υψηλότερο στις πόλεις σας.",
                totalPopulationTip: "Συνολικός πλυθησμός που παράγεται απο κατοικίες, υβρύδια κτιρίων πολιτισμού/πλυθησμού και αρχαία θαύματα",
                workingPopulationTip: "Εργαζόμενος Πλυθησμός - Το σύνολο που απαιτείται από τα κτίρια",
                availablePopulationTip: "Διαθέσιμος Πλυθησμός",
                totalCultureTip: "Συνολικός Πολιτισμός από πολιτιστικά κτίρια, υβρύδια κτιρίων πολιτισμού/πλυθησμού και αρχαία θαύματα",
                requiredCultureTip: "Απαιτούμενος Πολιτισμός για όλα τα κτίρια σας",
                availableCultureTip: "Διαθέσιμος Πολιτισμός",
            },
            cityCoverageTable: {
                heading: "Κάλυψη Πόλης",
                description: "Δείχνει πόσα κουτάκια χρησιμοποιούνται στις πόλεις των μελών για κάθε τύπο κτιρίου. Τα άδεια κουτάκια είναι κουτάκια που δεν χρησιμοποιούνται.",
                tiles: 'Τετράγωνα'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Εβδομαδιαία Μυνήματα Αναφορές",
                description: "Δημιουργούμε αυτόματα εβδομαδιαίες αναφορές τις οποίες μπορείτε εύκολα και γρήγορα να μοιραστείτε με τους συντρόφους σας. Μια αναφορά για την εβδομάδα που πέρασε θα είναι διαθέσιμη κάθε Κυριακή (γύρω στις 8μμ UTC). Απλά κάντε αντιγραφή το παρακάτω κείμενο και επικόλληση!",
                selectReportHint: "Επιλογή αναφοράς για την εβδομάδα που τελείωσε στις",
                reportsAreOptimizedFor: "Οι αναφορές αυτές είναι βέλτιστες για προβολή στο σύστημα τηλεγραφείου του έτσι ώστε οι στήλες να ευθυγραμμίζονται όσο το δυνατόν πιο σωστά και τα ονόματα των χρηστών να κόβονται για να χωράνε σε ένα μύνημα",
                accolades: "Διακρίσεις",
                tourneyChamp: " - Πρωταθλητής Τουρνούα (τρέχον εβδομάδα): {0}",
                tourneyHero: " - Ήρωας Τουρνουά (τελευταίες 4 εβδομάδες): {0}",
                highestGrowthPlusPercentage: " - Μεγαλύτερη Ανάπτυξη (πόντοι & ποσοστό): {0}",
                highestGrowthPoints: " - Μεγαλύτερη Άνοδος (πόντοι): {0}",
                highestGrowthPercentage: " - Μεγαλύτερη Ανάπτυξη (ποσοστό): {0}",
                highestGrowthError: " - Μεγαλύτερη Ανάπτυξη: Δεν μπορεί να καθοριστεί ακόμα. Απαιτείτε μεγαλύτερο ιστορικό",
                newPersonalRecords: "Νέα Προσωπικά Ρεκόρ",
                userSetANewPersonalRecordFor: " * {0} κατάφερε ένα νέο ρεκόρ: {1}",
                allMembersByPointGainThisWeek: "Όλα τα μέλη ανά ανάπτυξη πόντων / ποσοστό (τρέχον εβδομάδα)",
                tournamentPointsHeader: "Πόντοι Τουρνουά (τρέχον εβδομάδα / ΣΥΝΟΛΟ από {0})",
                top8ByPercentage: "TOP 8 ανά ποσοστό τρέχον εβδομάδα)",
                top8ByPointsSince: "TOP 8 ανά πόντους (από {0})",
                top8ByPercentageSince: "TOP 8 ανα ποσοστό (από {0})",
                reportGeneratedBy: "Η αναφορά δημιουργήθηκε από elvenstats.com, για περισσότερα, δείτε: ",
                mostPointsInAWeek: "Περισσότεροι Πόντοι σε μια εβδομάδα",
                highestTournamentScore: "Υψηλότερο Σκορ Τουρνουά",
                highestTournamentRank: "Υψηλότερη Κατάταξη Τουρνουά",
                insufficientHistoryForThesePlayers: "* Παραλήφθηκε: {0} λόγω ανεπαρκής ιστορικού.  Θα συμπεριληφθούν την επόμενη εβδομάδα",
                insufficientHistory1Week: "* Ανεπαρκής Ιστορικό για αυτό το κομμάτι. Ελέγξτε ξανά σε μια βδομάδα!",
                insufficientHistory4Weeks: "* Ανεπαρκής Ιστορικό για αυτό το κομμάτι. Απαιτείτα ιστορικό τεσσάρων εβδομάδων. Ελέγξτε ξανά σύντομα!",
            },
            memberHistory: {
                heading: "Ιστορικό Μελών",
                noChangesDetected: "Δεν εντοπίστηκε αλλαγή μελών από εκκίνηση παρακολούθησης συντροφιάς στις {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Έχετε μη αποθηκευμένες αλλαγές. Όταν τελειώσετε την επεξεργασία συντροφιάς, κάντε κλικ στο κουμπί αποθήκευσης.',
                standbyImporting: 'Αναμείνατε: Εισάγουμε μερικά από τα μέλη με ελλειπή πληροφορίες.',
                limitedHistory: "Μόλις πρόσφατα ξεκινήσαμε την παρακολούθηση {0} συνεπώς υπάρχει περιορισμένο ισοτιρκό.  Κάθε Κυριακή, τα εβδομαδιαία στιγμιότυπα θα εμφανίζονται εδώ, οπότε ελέγξτε ξανά σύντομα!",
                noChangesSinceTrackingBegan: "Καμία αλλαγή από την έναρξη παρακολούθησης",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Ιστορικό Συντροφιάς"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Οι ενημερώσεις σε πραγματικό χρόνο δεν είναι διαθέσιμες αυτή τη στιγμή.",
            realTimeUpdatesNotAvailableDescription: "Αυτό συμβαίνει συνήθως μετά την επαννεκίνηση των σέρβερ του Elvenar για την εισαγωγή νέας έκδοσης ή για συντήρηση. Μόλις συμβεί αυτό, το ElvenStats θα πρέπει να κάνει χειροκίνητη σύνδεση σε όλους τους σέρβερ του παιχνιδιού πριν την ανάκτηση των πληροφοριών.  Δοκιμάστε το αίτημά σας σε μερικές ώρες.  Εν τω μεταξύ, ο ιστότοπος είναι πλήρως λειτουργικός διαφορετικά.",
            copyToClipboardSuccessful: "Αντιγράφηκε επιτυχώς!",
            copyToClipboardFailed: "Αποτυχία αντιγραφής, επιλέξτε όλο το κείμενα και πατήστε CTRL+C",
            errorOccurredImporting: "Προέκυψε σφάλμα. Εισαγωγή χρηστών.",
            errorOccurredImportingMessage: "Ένα σφάλμα προέκυψε κατά την διάρκεια της εισαγωγής των χρηστών.  Παρακαλούμε δοκιμάστε ξανά.  Αν το σφάλμα εμένει, επικοινωνήστε μαζί μας.",
            errorOccurredImportingWillNotBeAvailableInReports: "Χρήστε οι οποίοι δεν έχουν εισαχθεί δεν θα εμφανίζονται στις αναφορές.",
            finishedSyncSuccessful: "Τέλος, επιτυχής συγχρονισμός!",
            playerIsAnonymous: "Ο παίκτης ζήτησε να μην εμφανίζονται οι πληροφορίες του στο elvenstats.com",
            inactiveWarningTip: "Πιθανόν ανενεργός χρήστης.  Τελευταία ενημέρωση σκορ: {0}",
            isFriendTip: "Αυτός ο χρήστης είναι φίλος του ElvenStats.  Συνείσφεραν χρόνο ή χρήματα για την υλοποίηση αυτού του site!",
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/gr.js